export default __webpack_public_path__ + "static/media/Armor-piercing Ammunition.ed7479f0.png";